export { default } from './InsuranceCard';
